'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    var ul = document.createElement('ul');
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        if (Object.keys(data[key]).length > 0) createTree(li, data[key]);
        ul.appendChild(li);
    }
    element.appendChild(ul);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.af364310.js.map
